// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"229":"7be6e681","298":"7d18773d"}[chunkId] + ".css";
};